import { Image, Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import { WatermarkSvgBigComponent } from 'PDF/components/WatermarkBig';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

import { PDFPage } from '../../components/Page';

interface ICoverPagePdf {
  name: string;
  description: string;
  logoUrl: string;
  isStandardOrLightTariff: boolean;
  sectionPicture?: string;
}

const colorIndexes = {
  green: 7,
  blue: 0,
  red: 0,
  blueGreen: 0,
  blueRed: 1,
  blueYellow: 0,
};

const getTitleStyles = (title: string) => {
  if (title.length > 60) {
    return styles.headingExtraLongLength;
  }
  if (title.length > 50) {
    return styles.headingLongLength;
  }
  if (title.length > 30) {
    return styles.headingMiddleLength;
  }
  return styles.headingDefault;
};

export const CoverPagePdf = ({
  name,
  description,
  logoUrl,
  sectionPicture,
  isStandardOrLightTariff,
}: ICoverPagePdf) => {
  return (
    <PDFPage paddings={'36px 0 50px 0'} isStandardOrLightTariff={isStandardOrLightTariff}>
      <View style={{ position: 'relative' }}>
        {!isStandardOrLightTariff && (
          <Link href="https://growexa.com" style={styles.watermarkLink}>
            <WatermarkSvgBigComponent />
          </Link>
        )}

        {!!logoUrl && <Image src={logoUrl} style={styles.icon} />}
        <View style={styles.wrapper}>
          <Text style={[styles.mainHeading, getTitleStyles(name), getColorObjectStyleByRecord(colorIndexes, 'color')]}>
            {name}
          </Text>
          <Text style={styles.bpHeadingWrapper}>
            {description?.split('')?.map((item, index) => (
              <Text style={styles.bpHeading} key={index}>
                {item}
              </Text>
            ))}
          </Text>
          <View style={styles.imageWrap}>
            {sectionPicture && <Image style={styles.image} src={sectionPicture}></Image>}
          </View>
        </View>
      </View>
    </PDFPage>
  );
};

const styles = StyleSheet.create({
  watermarkLink: {
    marginLeft: '36px',
    zIndex: 1000,
  },
  icon: {
    maxWidth: '122px',
    maxHeight: '72px',
    marginLeft: 'auto',
    marginRight: '36px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainHeading: {
    textTransform: 'uppercase',
    fontFamily: 'Noto',
    fontWeight: 700,
    marginLeft: '35px',
    maxWidth: '524px',
    fontSize: 36,
  },
  headingDefault: {
    marginTop: 90,
  },
  headingMiddleLength: {
    marginTop: 60,
  },
  headingExtraLongLength: {
    fontSize: 28,
    marginTop: 0,
  },
  headingLongLength: {
    marginTop: 0,
  },
  bpHeadingWrapper: {
    marginLeft: '35px',
    maxWidth: '524px',
  },
  bpHeading: {
    color: '#212121',
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: 21,
    maxWidth: '320px',
    lineHeight: 1.23,
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    flexBasis: 0,
    // padding: 2,
  },
  imageWrap: {
    marginTop: 'auto',
    padding: '11.7px 0 5.5px 0',
    paddingTop: '52px',
    position: 'relative',
  },
  image: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    height: 'auto',
    width: '100%',
    padding: '11.7px 0 5.5px 0',
    borderTop: '1px solid #4E5D56',
    borderBottom: '1px solid #4E5D56',
  },
});
